<template>
  <div class="log-star">
    <div style="margin-bottom:0.8rem">
      <el-button @click="addStar" size="small" type="success" icon="el-icon-plus">添加明星</el-button>
      <el-button :loading="logStarLoading" size="small" @click="saveStar" type="primary">保存</el-button>
    </div>
    <div v-for="(msg,index) in logisticDate" :key="index" class="introduction-box">
      <div class="log-star-box">
        <span class="trend-title">团队或个人名称</span>
        <el-input maxlength="10" show-word-limit type="text" placeholder="请输入" v-model="msg.name"></el-input>
      </div>
      <div class="log-star-box">
        <span class="trend-title">照片</span>
        <div style="display:inline-block;">
          <el-upload 
            class="avatar-uploader"  
            :http-request="(e)=>{uploadfile(e,index)}" 
            action="#" 
            :before-upload="beforeAvatarUpload"
            :show-file-list="false">
            <img v-if="msg.picture" :src="msg.picture" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
      <div class="log-star-box">
        <span class="trend-title">团队或个人介绍</span>
        <el-input maxlength="100" show-word-limit :rows="4" type="textarea" placeholder="请输入" v-model="msg.remark"></el-input>
        <el-button @click="removeStar(msg.id,index)" style="margin-left:1rem" type="primary" icon="el-icon-minus">删除</el-button>
      </div>
    </div>
    <!-- <div class="last-save">
      <el-button :loading="logStarLoading" size="small" @click="saveStar" type="primary">保存</el-button>
    </div> -->
  </div>
</template>

<script>
import api from '@/apis/transportation/transportation'
import upapi from '@/apis/upload'
export default {
  data(){
    return{
      logStarLoading:false,//加载状态
      logisticDate:[
        {name:'',picture:'',remark:''}
      ]
    }
  },
  mounted(){
    this.getStar()
  },
  methods:{
    //图片上传成功的回调函数
    uploadfile(val,i) {
      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          this.logisticDate[i].picture = res.data
        } else {
          this.$message.error(res.message)
          return;
        }
      })
    },
    //保存数据
    saveStar(){
      this.logStarLoading = true;
      api.saveStar(this.logisticDate).then(res=>{
        if(res.code==10000){
          this.logStarLoading = false;
          this.getStar()
          this.$message.success('保存成功');
        }else{
          this.logStarLoading = false;
          this.$message.error(res.message);
          return;
        }
      })
    },
    //获取数据
    getStar(){
      api.getStar().then(res=>{
        if(res.code==10000){
          if(res.data){
            this.logisticDate = res.data.list
          }
        }
      })     
    },
    //删除一行人员数据
    removeStar(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.delStar([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getStar()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.logisticDate.splice(index,1)
      }
    },
    //判断上传文件格式是否合法
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    //添加一行人员数据
    addStar(){
      this.logisticDate.unshift({name:'',picture:'',remark:''})
    },
  }
}
</script>
<style lang="less" scoped>
  .log-star{ padding-top: 10px;
    .introduction-box{display:inline-block; border: #3570ff solid 1px; position: relative; width: 45%; padding:1rem; margin-right:1rem; margin-bottom: 1rem; position: relative;
      .log-star-box{ display: flex; flex-direction: row; margin-bottom: 15px;
        .trend-title{ width: 8.5rem; flex-shrink: 0;}
        .el-input,.el-select{ width: 100%;}
      }
    }
  }
</style>